import { render } from "./leads-index.vue?vue&type=template&id=40d0d520&scoped=true"
import script from "./leads-index.vue?vue&type=script&lang=js"
export * from "./leads-index.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./leads-index.vue?vue&type=style&index=1&id=40d0d520&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d0d520"]])

export default __exports__